export default {
  nav: {
    dashboard: "Dashboard",
    businesses: "Businesses",
    whatsapp: "WhatsApp",
    agency: "My Sub-accounts",
    agents: "Agents",
    knowledge: "Knowledge Base",
    workflows: "Workflows",
    conversations: "Conversations",
    users: "Users",
    saasAdmin: "SaaS Admin",
    settings: "Settings",
    support: "Support",
    logout: "Log out",
  },
  auth: {
    welcome: "Welcome back",
    signInSub: "Sign in to your account",
    email: "Email",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    fillFields: "Please fill in all fields",
    loginFailed: "Login failed",
    noAccount: "Don't have an account?",
    createOne: "Create one",
    step1Title: "Step 1 · Choose your plan",
    step1Sub: "Both include a free 7-day trial — card required, nothing charged until day 8.",
    step2Title: "Step 2 · Create your account",
    step2Sub: "Just create your account. Use the same email you paid with.",
    paidBanner: "Payment received — create your account",
    paidBannerSub: "Your plan is active. Use the same email from checkout so we recognize it automatically.",
    name: "Name",
    confirmPassword: "Confirm password",
    createAccount: "Create my account",
    creating: "Creating account...",
    alreadyPaid: "I already paid — create my account",
    firstPlan: "Choose your plan in Step 1 first",
    firstPlanSub: "The account is created after payment. If you already bought in another tab, continue here:",
    loginInstead: "Already have an account? Sign in",
    perMonth: "USD/mo",
    fullName: "Full name",
    emailPaid: "Email (the same one from checkout)",
    haveAccount: "Already have an account?",
    tryFree: "Try 7 days free",
    toastPwdMismatch: "Passwords do not match",
    toastPwdShort: "Password must be at least 6 characters",
    toastCreated: "Account created! Welcome to LeadBot",
    namePh: "John Doe",
  },
  dash: {
    title: "Dashboard",
    tagline: "We make your life easier",
    subtitle: "Overview of your AI operations",
    businesses: "Businesses",
    activeLocations: "Active locations",
    activeAgents: "Active agents",
    conversations: "Conversations",
    leads: "Leads qualified",
    appointments: "Appointments",
    activeBusinesses: "Active businesses",
    crmConnected: "CRM connected",
    noCrm: "No CRM",
    planCard: "Your plan & AI credits",
    trialing: "Free trial",
    active: "Active",
    suspended: "Suspended",
    trialEnds: "ends {{date}}",
    aiMonth: "AI replies this month",
    packBalance: "AI packs: {{count}} replies left from your packs (consumed after the monthly included amount runs out).",
    limitReached: "You hit your cap — buy a pack or connect your own AI key in the number's Settings.",
    buyNumber: "+ Extra number",
    buySub: "+ Extra sub-account",
    buyCredits: "+ AI credits",
  },
  wa: {
    subtitle: "Manage your WhatsApp connections",
    docs: "Documentation",
    commands: "Commands",
    addWhatsapp: "Add WhatsApp",
    ghlBanner: "Connect your GoHighLevel. Your WhatsApp can connect, but messages won't reach your CRM until you link your sub-account. One click: authorize the app and it links itself.",
    connectNow: "Connect now",
    totalConnections: "Total Connections",
    active: "Active",
    disconnected: "Disconnected",
    connectedNumbers: "Connected Numbers",
    connectedNumbersSub: "Manage your WhatsApp connections and their status",
    disconnect: "Disconnect",
    refresh: "Refresh",
    noNumbers: "No numbers yet. Connect the first one by scanning a QR.",
    config: "Settings",
    groups: "Groups",
    connected: "Connected",
    disconnectedStatus: "Disconnected",
    connecting: "Connecting...",
    qrPending: "Scan the QR",

    menusNote: "Menus are saved to this number's business — all numbers in the same business can use them. Send a menu to a contact by writing #menu|slug in the CRM or the LeadBot chat. When the customer taps an option, the step you configured runs (message, another menu, tag).",
    yourBusiness: "their business",
    businessMenus: "Business menus",
    newMenu: "New menu",
    noMenus: "No menus yet. Create the first one.",
    optionsCount: "options",
    edit: "Edit",
    menuName: "Name",
    menuSlug: "Slug (for #menu|...)",
    menuBody: "Menu message",
    menuTitle: "Title (optional)",
    menuFooter: "Footer (optional)",
    menuOptions: "Options",
    optionTextPlaceholder: "Button {{n}} text (max 25 characters)",
    actionNone: "Record only",
    actionMessage: "Send message",
    actionMenu: "Open another menu",
    optionMessagePlaceholder: "Message sent if they pick this option",
    nextMenuPlaceholder: "Which menu comes next?",
    optionTagPlaceholder: "CRM tag on selection (optional)",
    addOption: "Add option",
    back: "Back",
    saveMenu: "Save menu",
    createMenu: "Create menu",
    close: "Close",

    smsFallback: "SMS fallback (if no WhatsApp)",
    callAutoReply: "Auto-reply to calls with a message",
    typingIndicator: "Typing Indicator",
    groupsSupport: "Groups Support",
    enableAgent: "Enable AI Agent",
    enableAgentNote: "Automatically replies to inbound messages with the business's assigned agent/workflow. The ai_off tag in the CRM silences it per contact.",
    syncOrganic: "Sync organic inbound messages with the CRM",
    syncOrganicNote: "When off, only inbound messages that belong to a conversation already started/linked in the CRM get synced. The rest only appear in LeadBot.",
    numbersUsage: "WhatsApp numbers: <strong>{{used}} / {{max}}</strong>",
    aiMonthShort: "AI this month",
    trialEndsAt: "your trial ends on {{date}}",
    regularizePayment: "catch up on your payment to reactivate the service",
    reactivatePlan: "Reactivate plan",

    generatingQr: "Generating QR code...",
    connectingRealtime: "Connecting in real time...",
    cancel: "Cancel",
    configTitle: "Configuration",
    configSub: "Configure the options for this WhatsApp number",
    openaiNote: "Your own AI: with your own key, replies run on your account (if left empty, the platform AI is used)",
    claudeNote: "If you enter it, the agent uses Claude (Anthropic) instead of OpenAI",
    claudeKey: "Claude API Key (optional)",
    aiModel: "AI Model (optional)",
    elevenNote: "For TTS voice notes",
    initialTag: "Initial Tag",
    initialTagNote: "Tag for new contacts",
    invalidTag: "Invalid Tag",
    invalidTagNote: "Set automatically when the number has no WhatsApp; their messages go out via SMS",
    smsOnlyTag: "SMS-only Tag",
    smsOnlyTagNote: "Put this tag on a contact in the CRM to force them to ALWAYS receive SMS, even if they have WhatsApp",
    broadcastDelay: "Broadcast Delay (seconds)",
    broadcastDelayNote: "seconds between broadcast messages",
    tabVoice: "Voice",
    tabFeatures: "Features",
    tabMenus: "Menus",
    saving: "Saving...",
    saveChanges: "Save changes",

    businessNoticeTitle: "Important: Use WhatsApp Business",
    businessNotice: "For contact syncing to work correctly, you must scan the QR code using the WhatsApp Business app, not regular WhatsApp. Regular WhatsApp hides sender phone numbers, which prevents correct contact identification in the CRM.",
    loadingSessions: "Loading sessions...",
    serviceDown: "WhatsApp service unavailable",
    serviceDownSub: "The service is starting or temporarily unavailable",
    retryConnection: "Retry connection",
    noWhatsapp: "No WhatsApp numbers connected",
    noWhatsappSub: "Add your first WhatsApp number to get started",
    noNumber: "No number assigned",
    connect: "Connect",

    title: "WhatsApp Gateway",
    selectBusiness: "Select business...",
    toastServiceStarted: "WhatsApp service started",
    toastLoadFailed: "Failed to load WhatsApp sessions",
    toastConnected: "WhatsApp connected successfully",
    toastSessionConnected: "WhatsApp {{phone}} connected",
    toastGroupJoined: "Added to group: {{name}}",
    newGroup: "New group",
    toastNameRequired: "Name is required",
    toastSelectBusiness: "Select a business first",
    toastSessionCreated: "Session created successfully",
    toastCreateFailed: "Failed to create session",
    toastPlanLimit: "Your plan doesn't allow more numbers",
    toastExtendPlan: "You can upgrade your plan here",
    viewPlans: "View plans",
    toastAlreadyConnected: "Already connected",
    toastQrFailed: "QR could not be loaded. Please try again.",
    toastConnectFailed: "Failed to connect WhatsApp",
    toastDisconnected: "WhatsApp disconnected",
    toastDisconnectFailed: "Failed to disconnect",
    toastSessionDeleted: "Session deleted",
    toastDeleteFailed: "Failed to delete session",
    toastConfigSaved: "Settings saved",
    toastSaveFailed: "Failed to save",
    toastConfigSaveFailed: "Failed to save settings",
    toastMenusLoadFailed: "Failed to load menus",
    toastMenuNeedName: "The menu needs a name and slug",
    toastMenuNeedOption: "Add at least one option with text",
    toastMenuChainMissing: "The option \"{{text}}\" opens another menu but you didn't pick which one",
    toastMenuSaved: "Menu saved",
    toastMenuSaveFailed: "Failed to save menu",
    toastMenuDeleted: "Menu deleted",
    toastMenuDeleteFailed: "Failed to delete menu",
    toastStartingService: "Trying to start WhatsApp service...",
    toastServiceStartedShort: "Service started",
    toastServiceStartFailed: "Failed to start service",
    toastServerError: "Failed to connect to the server",
    menuBroadcast: "Broadcast & Search",
    menuDelete: "Delete",
    addDesc: "Create a new WhatsApp connection for your business",
    nameLabel: "Name",
    namePh: "E.g.: Main WhatsApp",
    priorityLabel: "Priority",
    priorityHint: "Lower priority numbers are used first",
    create: "Create",
    deleteTitle: "Delete session",
    deleteDesc: "Are you sure you want to delete the session \"{{name}}\"? This action cannot be undone.",
    deleting: "Deleting...",
    qrTitle: "Scan QR Code",
    qrLive: "Real-time",
    qrDesc: "Open WhatsApp on your phone, go to Linked Devices and scan this code",
    tabGeneral: "General",
    tabWebhooks: "Webhooks",
    voiceProcessor: "Voice Processor",
    vpNone: "None",
    webhookMsg: "Message Webhook",
    webhookMsgNote: "Fires when a new message arrives",
    webhookDisc: "Disconnection Webhook",
    webhookDiscNote: "Fires when WhatsApp disconnects",
    audioTranscription: "Audio Transcription",
    showSourceLine: "Show source line in the CRM",
    waCallsTitle: "WhatsApp Calls",
    callsReplyLabel: "Call auto-reply message",
    callsReplyPh: "Thanks for your call. This channel is handled by message only. How can we help you?",
    callsReplyNote: "Calls can't be answered from here (WhatsApp Web limitation), but they're logged automatically in the contact's CRM history and this message is sent instantly. Empty = default message.",
    groupsConfigTitle: "Group Settings",
    autoJoin: "Auto-register when I'm added to a group",
    autoJoinNote: "When enabled, new groups are registered automatically (muted by default)",
    spintaxTitle: "Global Spintax (anti-spam)",
    spintaxDesc: "Define up to 6 reusable variables. One variant per line. Use them in any message as ${SPINTAX_1} and each send picks a random variant — identical mass messages are the #1 cause of bans.",
    spintaxLocked: "locked",
    spintax1Note: "Default platform opening greeting (not editable) — use it as ${SPINTAX_1} at the start of your campaign and workflow messages.",
    spintaxInlineNote: "You can also declare per-message spintax: !/SPINTAX_A/option 1/option 2/SPINTAX_A/! and use it as ${SPINTAX_A}. And add !/DELAY/1000/6000/! at the end to wait a random 1-6 sec before sending.",
    crmSyncTitle: "CRM Sync",
    menuNamePh: "Main menu",
    menuBodyPh: "How can I help you?",
  },

  agents: {
    title: "Agents",
    subtitle: "Create and manage your AI conversation agents",
    newAgent: "New Agent",
    noAgents: "No agents yet",
    noAgentsSub: "Create your first AI agent to get started",
    delete: "Delete",
    search: "Search agents...",
    activate: "Activate",
    deactivate: "Deactivate",
    unknown: "Unknown",
    filterBusiness: "Filter by business",
    deleted: "Agent deleted",
    deleteFailed: "Failed to delete agent",
    loadFailed: "Failed to load data",
    updateFailed: "Failed to update agent",
  },
  kbPage: {
    title: "Knowledge Base",
    subtitle: "Manage your AI agent knowledge with inline editing",
    newEntry: "New Entry",
    search: "Search entries...",
    createFirst: "Create your first knowledge base entry",
    deleteConfirm: "Delete this entry? This cannot be undone.",
    created: "Entry created",
    deleted: "Entry deleted",
    updated: "Entry updated (new version created)",
    createFailed: "Failed to create entry",
    deleteFailed: "Failed to delete entry",
    loadFailed: "Failed to load data",
    versionsFailed: "Failed to load versions",
    delete: "Delete",
    editInline: "Edit inline",
    versionHistory: "Version history",
    entryTitle: "Entry title...",
    noEntries: "No entries yet",
    noMatching: "No matching entries",
    adjustFilters: "Try adjusting your filters",
    showing: "Showing {{shown}} of {{total}} entries",
  },

  convo: {
    loadFailed: "Failed to load conversations",
    loadOneFailed: "Failed to load conversation",
    sendFailed: "Failed to send message",
    search: "Search...",
    noConversations: "No conversations",
    noMessages: "No messages",
    typeMessage: "Type a message...",
    unknown: "Unknown",
  },

  wf: {
    loadFailed: "Failed to load workflows",
    deleteFailed: "Failed to delete workflow",
    deleted: "Workflow deleted",
    unassigned: "Unassigned",
    subtitle: "Design visual automation flows for your agents",
    newWorkflow: "New Workflow",
    noWorkflows: "No workflows yet",
    noWorkflowsSub: "Create your first workflow to automate conversations",
  },

  agentEditor: {
    editAgent: "Edit Agent",
    newAgent: "New Agent",
    tabPersona: "Persona",
    tabKnowledge: "Knowledge",
    tabTest: "Test Chat",
    personaTitle: "Agent Persona",
    agentName: "Agent Name",
    agentNamePlaceholder: "e.g., Sales Assistant",
    tone: "Tone",
    personality: "Personality",
    personalityPlaceholder: "e.g., Helpful and concise",
    systemPrompt: "System Prompt",
    systemPromptPlaceholder: "Instructions for the AI agent...",
    businessContext: "Business Context",
    businessContextPlaceholder: "Describe the business, products, services...",
    kbTitle: "Knowledge Base",
    kbHint: "Select knowledge base entries to associate with this agent",
    kbEmpty: "No KB entries. Create some first.",
    kbSearch: "Search entries...",
    testTitle: "Test Chat",
    saveFirst: "Save the agent first to test the chat",
    agentResponse: "Agent response:",
    testPlaceholder: "Type a test message...",
    saving: "Saving...",
    saveAgent: "Save Agent",
    cancel: "Cancel",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    noResults: "No results for \"{{q}}\".",
    toneProfessional: "Professional",
    toneFriendly: "Friendly",
    toneCasual: "Casual",
    toneFormal: "Formal",
    toastLoadFailed: "Failed to load data",
    toastNameRequired: "Agent name is required",
    toastUpdated: "Agent updated",
    toastCreated: "Agent created",
    toastSaveFailed: "Failed to save agent",
    toastSaveFirst: "Save the agent first to test",
    toastTestFailed: "Test failed",
  },

  builder: {
    namePlaceholder: "Workflow name...",
    active: "Active",
    draft: "Draft",
    assignAgent: "Assign agent...",
    deactivate: "Deactivate",
    activate: "Activate",
    deleteNode: "Delete Node",
    nameRequired: "Workflow name is required",
    saveFirstActivate: "Save the workflow first before activating",
    saving: "Saving...",
    save: "Save",

    triggers: "Triggers",
    triggersNote: "No rules = the agent's default workflow. With rules, it only fires when they match (only if the conversation has no other workflow running).",
    ruleTag: "🏷 Tag",
    ruleKeyword: "🔑 Keyword",
    ruleChannel: "📱 Channel (number)",
    ruleNewContact: "✨ New contact",
    has: "Has",
    notHas: "Doesn't have",
    exact: "Exact",
    startsWith: "Starts with",
    keywordPlaceholder: "price",
    chooseNumber: "Choose the number",
    newContactNote: "Fires only if it's the contact's first conversation.",
    ifSeveral: "If multiple:",
    any: "Any",
    all: "All",
    priority: "Priority:",
    priorityNote: "If two workflows match, the HIGHER priority wins. E.g. FB campaign (priority 20) beats the general one (priority 10) — but if no rule matches, the default workflow runs.",
    addRule: "+ Add rule",

    operator: "Operator",
    equals: "Equals",
    notEquals: "Not Equals",
    contains: "Contains",
    greaterThan: "Greater Than",
    lessThan: "Less Than",
    calendar: "Calendar",
    enterIdManually: "Enter ID manually...",
    bookingMessage: "Booking Message",
    method: "Method",
    duration: "Duration",
    seconds: "Seconds",
    minutes: "Minutes",
    action: "Action",
    addTag: "Add Tag",
    removeTag: "Remove Tag",
    tagName: "Tag Name",
    endAction: "End Action",
    endComplete: "Mark conversation complete",
    endHandoff: "Hand off to human",
    endPause: "Pause conversation",
    finalMessage: "Final Message (optional)",
    endAddTag: "Add Tag on End (optional)",

    objectiveType: "Objective Type",
    giveInfo: "Give Info",
    gatherInfo: "Gather Info",
    dataToCollect: "Data to Collect",
    selectField: "Select field to collect...",
    customField: "Custom Field...",
    customFieldName: "Custom Field Name",
    customFieldPlaceholder: "e.g., Property type",
    customCrmField: "Custom CRM Field...",
    botPrompt: "Bot Prompt",
    botPromptNote: "Write naturally - the bot will phrase the question using your prompt as guidance",
    validation: "Validation",
    noValidation: "No validation",
    validEmail: "Must be valid email",
    validPhone: "Must be valid phone",
    validNumber: "Must be a number",
    notEmpty: "Cannot be empty",
    prefillTitle: "When the contact already has this data",
    alwaysAsk: "Always ask",
    alwaysAskDesc: "Ignore existing data, ask fresh",
    confirmExisting: "Confirm existing",
    confirmExistingDesc: "Show data & ask to confirm or correct",
    skipIfFilled: "Skip if filled",
    skipIfFilledDesc: "Auto-skip, move to next step",
    confirmPrompt: "Confirm Prompt (optional)",
    confirmPromptNote: "Use {value} to reference the existing data. The bot will ask to confirm or provide a new value.",
    informPrompt: "Information Prompt",
    informPromptNote: "The bot will use your Knowledge Base + this prompt to provide information",


    toastLoadFailed: "Failed to load workflow",
    toastNodeDeleted: "Node deleted",
    toastSaved: "Workflow saved",
    toastCreated: "Workflow created",
    toastSaveFailed: "Failed to save workflow",
    toastStatusFailed: "Failed to change workflow status",
    nodesHeader: "Nodes",
    paletteTip: "Tip: select a node or connection and press Delete/Backspace to remove it",
    fromSubaccount: "From your account ({{count}})",
    mapCrmField: "Map to CRM field...",
    maxTurns: "Max Turns",
    fieldLabel: "Field",
    valueLabel: "Value",
    selectCalendarPh: "Select a calendar...",
    calendarIdPh: "Calendar ID",
    calendarLoadFailed: "Could not load calendars automatically - paste the Calendar ID from your CRM",
    unit: "Unit",
    hours: "Hours",
    days: "Days",
    fieldFullName: "Full Name",
    fieldFirstName: "First Name",
    fieldLastName: "Last Name",
    fieldPhone: "Phone",
    fieldAddress: "Address",
    fieldCity: "City",
    fieldState: "State / Province",
    fieldZip: "ZIP Code",
    fieldCompany: "Company Name",
    fieldBudget: "Budget",
    fieldServiceInterest: "Service Interest",
    fieldPreferredDate: "Preferred Date",
    endHandoffNote: "The AI will stop responding and notify human agents",
    endPauseNote: "The AI will pause but can be reactivated",
    endCompleteNote: "The workflow will complete and the AI will stop",
    finalMessagePh: "e.g., Thank you for your time! Our team will follow up shortly.",
    endAddTagNote: "This tag will be added to the contact when the workflow ends",
  },

  nodes: {
    objective: "Objective",
    conversation: "Conversation",
    condition: "Condition",
    booking: "Booking",
    delay: "Delay",
    tag: "Add/Remove Tag",
    end: "End Workflow",
  },

  agency: {
    loading: "Loading agency panel...",
    forbiddenNote: "The Agency plan lets you create sub-accounts to resell LeadBot to your own clients, each with its whitelabel activation link.",
    whitelabel: "White label",
    whitelabelNote: "When your clients open their activation link, they'll see your brand (name and logo) instead of LeadBot — the panel feels 100% yours.",
    brandName: "Your brand name",
    brandLogo: "Your logo URL",
    brandNamePlaceholder: "e.g. Studio MX",
    saving: "Saving...",
    saveBrand: "Save brand",
    preview: "Preview:",
    subtitle: "Create sub-accounts for your clients and share their activation link — each client only sees their own, with no LeadBot branding.",
    subaccounts: "Sub-accounts",
    linesAssigned: "Lines assigned",
    linesAvailable: "Lines available",
    newSub: "New sub-account",
    clientName: "Client or business name",
    whatsappLines: "WhatsApp lines",
    clientNamePlaceholder: "e.g. López Dental Clinic",
    createSub: "Create sub-account",
    noSubs: "No sub-accounts yet. Create the first one above.",
    name: "Name",
    lines: "Lines",
    linesInUse: "lines in use",
    copyActivation: "Copy activation link",
    howToTitle: "How your client uses it:",
    howTo: "you share their activation link (paste it as-is, or as a Custom Menu Link inside your GoHighLevel agency so it appears in their sub-account's side menu). When they open it they land directly in their panel, connect their QR, and only see their own business.",
    toastBrandSaved: "Brand saved — your clients will see it in their panel",
    toastLinkCopied: "Link copied — share it with your client",
    toastExtendPlan: "You can upgrade your plan here",
  },

  saas: {
    accessDenied: "Access Denied",
    superAdminRequired: "Super Admin access required",
    title: "SaaS Management",
    subtitle: "Manage agencies, plans, and subscriptions",
    refresh: "Refresh",
    totalAgencies: "Total Agencies",
    activeAgencies: "Active Agencies",
    mrr: "MRR",
    subscriptionPlans: "Subscription Plans",
    newPlan: "New Plan",
    agencies: "Agencies",
    newAgency: "New Agency",
    editAgency: "Edit Agency",
    createAgency: "Create New Agency",
    editPlan: "Edit Plan",
    createPlan: "Create New Plan",
    waNumbersTotal: "WhatsApp Numbers (total)",
    realLimits: "Real limits (billing)",
    aiCreditsPerMonth: "AI credits per month (0 = unlimited)",
  },
  cmds: {
    title: "WhatsApp Commands",
    subtitle: "Automatic replies with /command",
    newCommand: "New Command",
    createCommand: "Create Command",
    bannerTitle: "Command System",
    bannerText: "When a contact sends a message starting with /, the command is looked up and replied to automatically. You can add tags and fire webhooks to build automations in the CRM.",
    listTitle: "Configured Commands",
    listSub: "List of commands available to your WhatsApp contacts",
    loading: "Loading commands...",
    emptyTitle: "No commands configured",
    emptySub: "Create your first command for automatic replies",
    inactive: "Inactive",
    uses: "uses",
    editTitle: "Edit Command",
    newTitle: "New Command",
    modalSub: "Configure the automatic reply and command actions",
    triggerLabel: "Command (without /)",
    triggerPh: "price, hours, info...",
    triggerHint: "Users will type /{{cmd}}",
    triggerFallback: "command",
    responseLabel: "Reply",
    responsePh: "The message that will be sent automatically...",
    addTagsLabel: "Add Tags",
    tagsHint: "Comma separated",
    removeTagsLabel: "Remove Tags",
    webhookLabel: "Webhook URL (optional)",
    webhookHint: "A POST with contact data will be sent when the command is used",
    scopeLabel: "Scope",
    scopeAll: "All",
    scopeGroups: "Groups Only",
    scopeIndividual: "Individual Only",
    activeLabel: "Active",
    cancel: "Cancel",
    saveChanges: "Save Changes",
    toastLoadFailed: "Failed to load commands",
    toastRequired: "Command and reply are required",
    toastNoBusiness: "Business not found",
    toastUpdated: "Command updated",
    toastCreated: "Command created",
    toastSaveFailed: "Failed to save command",
    toastDeleted: "Command deleted",
    toastDeleteFailed: "Failed to delete command",
    confirmDelete: "Delete command /{{trigger}}?",
  },
  biz: {
    title: "Businesses",
    subtitle: "Manage your business locations and configurations",
    addBusiness: "Add Business",
    editBusiness: "Edit Business",
    createBusiness: "Create Business",
    basicInfo: "Basic Information",
    nameLabel: "Business Name *",
    namePh: "e.g., The Brokers Real Estate",
    descLabel: "Description",
    descPh: "Brief description of the business",
    ghlConfig: "GoHighLevel Configuration",
    locationIdHint: "Found in GHL Settings → Business Profile",
    apiKeyLabel: "GHL API Key (Optional)",
    apiKeyHint: "Leave empty to use the global API key. Use for business-specific integrations.",
    doctorTitle: "GHL Connection Doctor",
    doctorDesc: "Run a full diagnostic of the GoHighLevel connection for this business.",
    doctorRun: "Run GHL Doctor",
    doctorRunning: "Diagnosing...",
    oauthConnect: "Connect OAuth Marketplace",
    oauthGenerating: "Generating URL...",
    oauthStatus: "OAuth Status",
    connected: "Connected",
    notConnected: "Not Connected",
    agentCalendar: "Agent & Calendar",
    defaultAgent: "Default Agent",
    selectAgent: "Select agent...",
    none: "None",
    defaultCalendar: "Default Calendar",
    selectCalendar: "Select calendar...",
    calendarField: "Calendar Custom Field",
    calendarFieldHint: "GHL custom field that contains the calendar ID per contact",
    openaiTitle: "OpenAI API Key (Optional)",
    bizApiKeyLabel: "Business-specific API Key",
    bizApiKeyPh: "sk-proj-... (leave empty to use global key)",
    bizApiKeyHint: "If set, this business will use its own OpenAI key instead of the global one",
    embedTitle: "GHL Embed URL",
    embedLabel: "Custom Menu Link for GHL",
    embedCopied: "Embed URL copied!",
    embedRegenerate: "Regenerate Token",
    embedTokenGenerated: "Embed token generated",
    embedTokenFailed: "Failed to generate token",
    embedGenerate: "Generate Embed URL",
    embedHint: "Generate a secure URL to embed LeadBot in GHL's custom menu",
    embedUseHint: "Use this URL in GHL Settings → Custom Menu Links → \"Open as embedded page (iFrame)\"",
    cancel: "Cancel",
    updateBusiness: "Update Business",
    createBusinessBtn: "Create Business",
    emptyTitle: "No businesses yet",
    emptyAdmin: "Create your first business to get started",
    emptyUser: "No businesses available",
    statusActive: "active",
    agentsCount: "Agents",
    ghlNo: "No GHL",
    calYes: "Cal",
    calNo: "No Cal",
    clientView: "Customer view",
    clientViewSim: " (simulated)",
    removePlan: "Remove plan",
    removePlanSim: "Remove simulated plan",
    simPersonal: "Simulate Personal",
    simAgency: "Simulate Small Agency",
    whitelabelLink: "Whitelabel link (for their CRM menu)",
    activationCopied: "Activation link copied",
    webhookCopied: "Webhook URL copied!",
    confirmDelete: "Delete \"{{name}}\"? This cannot be undone.",
    toastAdminRequired: "Admin access required",
    toastLoadFailed: "Failed to load data",
    toastNoBusiness: "No business selected",
    toastDoctorOk: "GHL Doctor: healthy connection",
    toastDoctorIssues: "GHL Doctor: issues found",
    toastDoctorError: "Error running diagnostics",
    toastOauthOpening: "Opening OAuth install in GHL Marketplace",
    toastOauthFailed: "Could not generate OAuth URL",
    toastNameRequired: "Business name is required",
    toastUpdated: "Business updated",
    toastCreated: "Business created",
    toastSaveFailed: "Failed to save business",
    toastDeleted: "Business deleted",
    toastDeleteFailed: "Failed to delete business",
    toastSimCleared: "Simulated plan removed",
    toastSimSet: "{{plan}} plan simulated (active)",
    toastSimFailed: "Could not simulate plan",
  },
  usr: {
    title: "User Management",
    subtitle: "Manage platform users and permissions",
    addUser: "Add User",
    searchPh: "Search users...",
    editUser: "Edit User",
    createUser: "Create User",
    fullName: "Full Name",
    role: "Role",
    roleUser: "User (Business Admin)",
    roleAdmin: "Admin (Super Admin)",
    roleHint: "Super Admins can manage all businesses. Business Admins are limited to one business.",
    assignedBusiness: "Assigned Business *",
    selectBusiness: "Select business...",
    businessHint: "The user will only have access to resources within this business.",
    cancel: "Cancel",
    updateUser: "Update User",
    createUserBtn: "Create User",
    emptyTitle: "No users found",
    emptyCreate: "Create your first user",
    emptySearch: "Try adjusting your search",
    inactive: "Inactive",
    joined: "Joined",
    statsTotal: "total users",
    statsAdmins: "admins",
    statsActive: "active",
    toastAdminRequired: "Admin access required",
    toastLoadFailed: "Failed to load data",
    toastUpdated: "User updated",
    toastUpdateFailed: "Failed to update user",
    toastRequired: "Please fill in all required fields",
    toastNeedBusiness: "Regular users must be assigned to a business",
    toastCreated: "User created",
    toastCreateFailed: "Failed to create user",
    toastActivated: "User activated",
    toastDeactivated: "User deactivated",
    toastStatusFailed: "Failed to update user status",
  },
  groups: {
    title: "WhatsApp Groups",
    noNumber: "No number",
    extract: "Extract Groups",
    reextract: "Re-extract Groups",
    extracting: "Extracting...",
    muteAll: "Mute All",
    extractLegend: "After clicking Extract Groups, you must manually re-enter each group with the Enter button to activate its sync.",
    bannerTitle: "Three states per group",
    bannerText: "Not joined: nothing reaches the CRM (default). Enter: messages reach the group's thread in the CRM. Mute (bell): messages KEEP reaching the CRM, but are marked as read so the app doesn't notify you constantly. Leave: they stop arriving. Groups never trigger menus or the AI agent.",
    totalGroups: "Total Groups",
    mutedCount: "Muted",
    soundCount: "With sound",
    listTitle: "Groups",
    listSub: "Manage notifications and AI processing per group",
    loading: "Loading groups...",
    emptyTitle: "No groups extracted",
    emptySub: "Click \"Extract Groups\" to import this WhatsApp's groups",
    badgeActiveSound: "Active · with sound",
    badgeActiveMuted: "Active · muted",
    badgeAiOn: "AI On",
    participants: "{{count}} participant",
    participants_plural: "{{count}} participants",
    messages: "{{count}} message",
    messages_plural: "{{count}} messages",
    lastMessage: "Last message",
    noActivity: "No activity",
    enter: "Enter",
    leave: "Leave",
    titleMute: "Mute: messages keep reaching the CRM but without notifying",
    titleUnmute: "Unmute: messages arrive and notify",
    settingsTitle: "Group Settings",
    muteGroup: "Mute Group",
    muteGroupDesc: "No visual alerts. Group sync stays active.",
    aiOffDesc: "The agent does NOT reply in this group",
    aiOnDesc: "The agent replies in this group",
    mutedBanner: "Group muted: you won't see alerts, but messages keep arriving and syncing.",
    cancel: "Cancel",
    saveChanges: "Save Changes",
    toastLoadFailed: "Failed to load groups",
    toastExtracting: "Extracting WhatsApp groups...",
    toastExtracted: "Extracted {{count}} groups",
    toastExtractFailed: "Failed to extract groups",
    toastSaved: "Settings saved",
    toastSaveFailed: "Failed to save settings",
    toastAllMuted: "All groups muted",
    toastAllUnmuted: "All groups activated",
    toastUpdateFailed: "Failed to update group",
    toastJoined: "You joined group \"{{name}}\"",
    toastJoinFailed: "Failed to join group",
    toastLeft: "You left group \"{{name}}\"",
    toastLeaveFailed: "Failed to leave group",
    toastMuted: "\"{{name}}\" muted: messages keep reaching the CRM without notifying",
    toastUnmuted: "\"{{name}}\" with sound: messages arrive and notify",
  },

  bcast: {
    title: "Search & Broadcast",
    noNumber: "No number",
    tabBroadcast: "Broadcast to Groups",
    tabSearch: "Search Messages",
    broadcastTitle: "Send Message to Multiple Groups",
    broadcastSub: "Select the groups and write the message you want to post",
    messageLabel: "Message",
    messagePh: "E.g.: Looking for a house for sale in the north area...",
    selectGroups: "Select Groups ({{sel}}/{{total}})",
    selectAll: "Select All",
    deselectAll: "Deselect All",
    noGroups: "No groups available. Extract the groups first.",
    participants: "{{count}} participant",
    participants_plural: "{{count}} participants",
    messages: "{{count}} message",
    messages_plural: "{{count}} messages",
    activeBadge: "Active",
    delayLabel: "Delay between messages",
    delayHint: "seconds (min: 1s, recommended: 2-5s)",
    delayNote: "A longer delay reduces the risk of WhatsApp bans. For {{count}} groups, estimated time: ~{{secs}}s",
    sending: "Sending...",
    sendTo: "Send to {{count}} group(s)",
    sentCount: "{{count}} sent",
    failedCount: "{{count}} failed",
    failedLabel: "Failed",
    searchTitle: "Search in Messages",
    searchSub: "Search text inside the saved messages of your groups and contacts",
    searchPh: "E.g.: condo for rent boardwalk...",
    allGroups: "All groups",
    searchBtn: "Search",
    searching: "Searching...",
    noResults: "No results",
    noResultsHint: "Type something to search in messages",
    toastSearchEmpty: "Type something to search",
    toastFound: "Found {{count}} messages",
    toastSearchFailed: "Search failed",
    toastSelectGroups: "Select at least one group",
    toastWriteMessage: "Write a message",
    toastSent: "Message sent to {{count}} groups",
    toastFailed: "{{count}} groups failed",
    toastSendFailed: "Failed to send messages",
  },
  stg: {
    title: "Settings",
    subtitle: "Configure AI and GoHighLevel integration",
    tabCredentials: "Credentials",
    tabGuide: "Setup Guide",
    oauthTitle: "GoHighLevel Connection",
    connectedBadge: "Connected",
    oauthWarnTitle: "Required step:",
    oauthWarnText: "without this connection your WhatsApp messages won't reach your CRM.",
    oauthStep1: "Click Connect with GoHighLevel.",
    oauthStep2: "In the window that opens, choose your account and authorize the app.",
    oauthStep3: "Done — your account is linked automatically (the app recognizes your account on its own, no manual tokens or IDs).",
    oauthLinkedVia: "Your account is linked via",
    viaToken: "private token",
    syncActive: "Message sync is active.",
    oauthOpening: "Opening GoHighLevel...",
    oauthReconnect: "Reconnect / switch account",
    oauthConnectBtn: "Connect with GoHighLevel",
    marketplaceNote: "It's the same GoHighLevel Marketplace app — you can also install it from there, the result is identical.",
    toastAuthorize: "Authorize the app in the GoHighLevel window; when done close it and come back here",
    toastConnectFailed: "Could not start the GoHighLevel connection",
    embedTitle: "Your account is managed by your provider",
    embedDesc1: "The connection with your CRM and the main credentials are managed by your service provider — you don't need to configure anything here.",
    embedDesc2: "To adjust your number's AI (your own OpenAI or Claude key), go to",
    embedPath: "WhatsApp → your number's ⋮ menu → Settings → General",
    envConfigured: "API key configured via environment. You can override it below for specific businesses.",
    globalOpenai: "Global OpenAI API Key",
    envKeyPh: "Using environment key (optional override)",
    getKeyFrom: "Get your API key from",
    claudeKeyLabel: "Global Claude API Key (optional)",
    claudeKeyPh: "sk-ant-... (if entered, Claude becomes the global default)",
    aiModelLabel: "Global AI Model (optional)",
    aiModelPh: "gpt-4o-mini / claude-sonnet-4-5",
    priorityLabel: "Priority:",
    priorityText: "number key (WhatsApp Settings) → business key → this global key → platform",
    webhookDesc: "Use this URL in your GHL workflow 'Process Message' webhook action",
    webhookCopied: "Webhook URL copied!",
    ghlCredsTitle: "GHL API Credentials",
    ghlEnvConfigured: "GHL credentials configured via environment.",
    pitLabel: "Private Integration API Key",
    locationLabel: "Default Location ID",
    locationPh: "Enter your GHL Location ID",
    doctorTitle: "GHL Connection Doctor",
    doctorDesc: "Run a full diagnostic (credentials, location, API ping, webhook) and quickly fix connection issues.",
    selectBizLabel: "Select Business to diagnose",
    selectBizPh: "Select a business...",
    selectBizHint: "Select a business to run the diagnostic and connect OAuth.",
    sinGhl: "(No GHL)",
    runDoctor: "Run GHL Doctor",
    doctorRunning: "Diagnosing...",
    oauthConnect: "Connect OAuth Marketplace",
    oauthGenerating: "Generating URL...",
    oauthStatus: "OAuth Status",
    configured: "Configured",
    missing: "Missing",
    connected: "Connected",
    notConnected: "Not Connected",
    customFieldsTitle: "GHL Custom Fields",
    customFieldsWarn: "Create these custom fields in your GHL account (Settings > Custom Fields) before connecting.",
    botResponseLabel: "Bot Response Field Key",
    botResponseHint: "GHL uses {{contact.salesbot_response}} to send the bot's reply",
    goalsLabel: "Goals Accomplished Field Key",
    goalsHint: "Tracks which objectives the bot has completed",
    statusTitle: "Integration Status",
    labelResponse: "Response Field",
    statusNotSet: "Not Set",
    saving: "Saving...",
    saveSettings: "Save Settings",
    toastSaved: "Settings saved",
    toastSaveFailed: "Failed to save settings",
    toastDoctorOk: "GHL Doctor: healthy connection",
    toastDoctorIssues: "GHL Doctor: issues found",
    toastDoctorFailed: "Could not run GHL diagnostic",
    toastOauthOpening: "Opening OAuth install in GHL Marketplace",
    toastOauthFailed: "Could not generate OAuth URL",
    step1Title: "Step 1:",
    step1Name: "Connect your CRM account",
    g1s1: "Go to the Credentials tab and press 'Connect OAuth Marketplace'.",
    g1s2: "Authorize the LeadBot installation on the account you want to use.",
    g1s3: "When you come back, the account is connected automatically — no need to copy keys manually.",
    step2Title: "Step 2:",
    step2Name: "Select LeadBot as the phone provider",
    required: "REQUIRED",
    g2s1: "In the CRM, go to Settings → Phone Numbers and click your number.",
    g2s2: "Open the 'Phone provider' tab (Advanced settings).",
    g2s3: "Choose 'LeadBot Gateway' instead of 'Lead Connector' and press Save.",
    g2s4: "Verify LeadBot Gateway is marked as 'Default'.",
    g2Warn1Strong: "Without this step, messages don't go out over WhatsApp.",
    g2Warn1Text: "Everything (manual conversations, workflows and bulk sends) goes through LeadBot once it's the selected provider.",
    g2Warn2: "Only agency owners and admins see this screen. If you ever uninstall and reinstall the app on the account, this step must be repeated.",
    step3Title: "Step 3:",
    step3Name: "Connect your WhatsApp number",
    g3s1: "In LeadBot, go to the WhatsApp section and press 'Add WhatsApp'.",
    g3s2: "Scan the QR code with the WhatsApp Business app (not regular WhatsApp).",
    g3s3: "Once the status changes to 'Connected', you can send and receive messages.",
    g3NotePre: "If you have several numbers, add them all here — the order you connect them sets their priority (you can change it per conversation with the command",
    g3NotePost: ").",
    step4Title: "Step 4:",
    step4Name: "Commands, buttons and menus",
    g4Text: "You can send buttons, lists, locations, voice notes and sequence menus by typing commands directly in the conversation. All the syntax with ready-to-copy examples is in:",
    g4Btn: "Open commands documentation",
    cfTitle: "Custom fields in the CRM",
    cfDescPre: "Create these",
    cfDescStrong: "custom fields",
    cfDescPost: "in your account (Settings > Custom Fields > Contact), only if you use the AI bot:",
    cfBotStrong: "The bot is enabled by default.",
    cfBotTextPre: "You don't need the 'ai_on' tag. The bot is only disabled when the contact has the tag",
    cfBotTextPost: "To re-enable it, simply remove the tag.",
    cf1desc: "Text field - stores the bot's reply",
    cf2desc: "Text field - logs accomplished objectives",
    cf3desc: "Text field - logs the channel (SMS, WhatsApp, etc.)",
    legacyTitle: "Advanced automation (legacy)",
    legacyDesc: "CRM workflows for the classic custom-field AI bot. They are NOT required to send or receive WhatsApp — only if you use that bot flow.",
    wf1Title: "Workflow 1:",
    wf1s1: "Add 'Customer Replied' triggers for each channel (WhatsApp, SMS, Email, Instagram, Facebook, Chat, GMB)",
    wf1s2: "Add a 'Contact Changed' action to save the message history",
    wf1s3: "Add a branch/switch that checks which trigger fired",
    wf1s4: "In each branch: update the 'last_communication_type' field with the channel name (e.g. 'SMS', 'WhatsApp')",
    wf1s5: "Add a filter for 'stop' / 'not interested' messages → add the 'ai_off' tag",
    wf2Title: "Workflow 2:",
    legacyBadge: "Legacy",
    wf2s1: "Add 'Customer Replied' triggers for all channels",
    wf2s2: "Add condition: if 'Tags' does NOT include 'ai_off' → continue; otherwise → END",
    wf2s3: "Add a Webhook (POST) action with this configuration:",
    wf2s4: "Optionally add a follow-up timer (triggers Workflow: Follow Up 1 Day)",
    wf3Title: "Workflow 3:",
    wf3s1: "Add the 'Bot Replied' trigger (fires when salesbot_response updates)",
    wf3s2: "Add condition: if 'Tags' does NOT include 'ai_off'",
    wf3s3: "Add a channel-check branch based on 'last_communication_type'",
    wf3s4: "For each channel, add the send action (SMS, WhatsApp, Messenger, etc.) with the message:",
    wf4Title: "Workflow 4:",
    optionalBadge: "Optional",
    wf4s1: "Add a 1-day wait timer",
    wf4s2: "Verify the 'ai_off' tag is NOT present",
    wf4s3: "Send a POST webhook to the same URL with:",
    flowTitle: "Complete flow",
    flow1: "Customer replies",
    flow2: "CRM Workflow 2",
    flow3: "Webhook to LeadBot",
    flow4: "AI generates the reply",
    flow5: "Updates salesbot_response",
    flow6: "CRM Workflow 3",
    flow7: "Sends via the right channel",
  },
  waDocs: {
    back: "Back",
    title: "Documentation & User Manual",
    subtitle: "Messaging commands, number settings and group controls, menus and AI agent",
  },
};
